import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { MapPin, ArrowRight } from "lucide-react";
import { API } from "../lib/api";
import CarCard from "./CarCard";

// Shown when the chosen city has only a few listings: other cars from the same state.
export default function NearbyCars({ state, city, cityCount, min = 4, className = "" }) {
  const [cars, setCars] = useState([]);
  useEffect(() => {
    if (!state || !city || cityCount >= min) { setCars([]); return; }
    let stale = false;
    axios.get(`${API}/listings`, { params: { state, limit: 24 } })
      .then((r) => !stale && setCars(r.data.items.filter((c) => c.city !== city).slice(0, 8)))
      .catch(() => !stale && setCars([]));
    return () => { stale = true; };
  }, [state, city, cityCount, min]);

  if (!cars.length) return null;
  return (
    <section className={className} data-testid="nearby-cars">
      <div className="flex items-end justify-between mb-4 gap-4">
        <div>
          <p className="eyebrow !text-[10px] mb-1 flex items-center gap-1"><MapPin className="w-3 h-3" />Nearby in {state}</p>
          <h2 className="font-display text-2xl sm:text-3xl">More cars near {city}</h2>
        </div>
        <Link to={`/cars?state=${encodeURIComponent(state)}`} className="btn-outline !py-1.5 !px-3 text-xs" data-testid="nearby-view-state">All of {state} <ArrowRight className="w-3.5 h-3.5" /></Link>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">{cars.map((c, i) => <CarCard key={c.id} car={c} index={i} />)}</div>
    </section>
  );
}
